import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import { ThemeProvider } from './context/ThemeContext.jsx';
import './index.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Article from './pages/Article.jsx';
import Privacy from './pages/Privacy.jsx';
import Cookies from './pages/Cookies.jsx';
import Terms from './pages/Terms.jsx';
import Quiz from './pages/Quiz.jsx';

const ScrollToHash = () => {
  const location = useLocation();
  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash;
    let attempts = 0;
    const tryScroll = () => {
      const el = document.querySelector(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      } else if (attempts < 40) { // ~2s total
        attempts += 1;
        setTimeout(tryScroll, 50);
      }
    };
    tryScroll();
  }, [location]);
  return null;
};

/**
 * Punctul de intrare al aplicaţiei.  Încarcă rutele pentru homepage şi pagini dedicate.
 */
try {
  const rootElement = document.getElementById('root');
  if (!rootElement) {
    throw new Error('Root element not found');
  }

  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <ThemeProvider>
        <BrowserRouter>
          <ScrollToHash />
          <Routes>
            <Route path="/" element={<App />} />
            <Route path="/article/:id" element={<Article />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/cookies" element={<Cookies />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/quiz" element={<Quiz />} />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </React.StrictMode>
  );
} catch (error) {
  console.error('Failed to render application:', error);
  const rootElement = document.getElementById('root');
  if (rootElement) {
    rootElement.innerHTML = `
      <div style="padding: 2rem; text-align: center; font-family: system-ui;">
        <h1>Eroare la încărcare</h1>
        <p>Vă rugăm să reîncărcați pagina.</p>
        <button onclick="window.location.reload()" style="margin-top: 1rem; padding: 0.5rem 1rem; cursor: pointer;">
          Reîncarcă pagina
        </button>
      </div>
    `;
  }
}
